// extracted by mini-css-extract-plugin
export default {"header-row":"TeamsHeader_header-row__dtF3b","filter-row":"TeamsHeader_filter-row__VT7Ea"};